<template>
  <div
    class="bg-white rounded-xl border border-untitled-gray-100 shadow-sm hover:shadow-md transition-shadow duration-150 p-4 flex flex-col gap-2"
  >
    <div class="flex items-start justify-between gap-2">
      <p
        class="text-sm font-semibold text-untitled-gray-800 capitalize break-words min-w-0"
      >
        {{ event.name }}
      </p>
      <StarIcon
        v-if="event.is_featured"
        class="w-5 h-5 text-amber-400 shrink-0"
        aria-label="Featured"
      />
    </div>

    <div class="text-xs text-untitled-gray-500 line-clamp-2">
      {{ event.description }}
    </div>

    <p class="text-xs text-untitled-gray-400">{{ startDate }}</p>

    <button
      type="button"
      class="self-start text-xs font-semibold text-app-primary hover:text-app-secondary underline underline-offset-2"
      @click="openRegisterLink"
    >
      Register Now
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { defineProps } from "vue";
import { StarIcon } from "@heroicons/vue/solid";

const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    default: "",
  },
  time: {
    type: String,
    default: "",
  },
  startDate: {
    type: String,
  },
});

const event = computed(() => props.event);
const startDate = computed(() => props.startDate);

const openRegisterLink = () => {
  window.open(event.value.url, "_blank");
};
</script>

<style scoped></style>
